<template>
    <div class="c-request-button">
        <Request
                ref="request"
                :method="method"
                :onRequestSuccess="onRequestSuccess"
                :onRequestError="onRequestError"
                :options="options"
                :root="root">
            <slot slot="body">
                <b-button @click="onClick" :class="buttonClass"><i v-if="iconClass!==''"
                        :class="iconClass"></i>{{label}}</b-button>
                <br/>
                <small class="form-text text-muted">{{description}}</small>
            </slot>
        </Request>
    </div>
</template>


<script>
    import Request from './Request'
    export default {
        name: 'RequestButton',
        components: {
            Request
        },
        props: {
            options: {
                type: Object,
                default: function() {
                    return {
                        showAlert: true,
                        blockOnProcessing: true,
                        blockTransparent: false,
                        blockImg: '',
                        blockSpinner: 'wave'
                    }
                }
            },
            root: {
                type: String,
                default: ''
            },
            method: {
                type: String,
                default: 'GET'
            },
            label: {
                type: String,
                default: ''
            },
            buttonClass: {
                type: String,
                default: 'btn btn-light'
            },
            iconClass: {
                type: String,
                default: ''
            },
            description: {
                type: String,
                default: ''
            }
        },
        watch: {
        },
        mounted() {
        },
        data: () => {
            return {
                Core: window.Core,
                Mantle: window.Mantle
            }
        },
        methods: {
            onClick() {
                this.$refs.request.clearArgs()
                this.$refs.request.request()
            },
            onRequestSuccess(data) {
                this.$emit('onRequestSuccess', data)
            },
            onRequestError() {

            }
        }
    }
</script>
